import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo los productos después de pagar?',
  a: 'De forma inmediata. Al confirmar el pago, recibís los archivos al instante en tu email. También podés descargarlos desde la confirmación de compra.'
}, {
  q: '¿Los precios están en pesos argentinos?',
  a: 'Sí, todos los precios son en ARS. El pago se procesa por Mercado Pago con tarjeta de crédito, débito o transferencia.'
}, {
  q: '¿Funciona en Google Sheets o solo en Excel?',
  a: 'Funciona en ambos. Los archivos son .xlsx compatibles con Excel y Google Sheets. Algunas fórmulas menores pueden necesitar ajuste en Sheets.'
}, {
  q: '¿Necesito conocimientos de Excel o contabilidad?',
  a: 'No. Cada archivo tiene una pestaña de Guía de Uso con instrucciones paso a paso. Solo completás las celdas en azul.'
}, {
  q: '¿Cada cuánto debo actualizar los datos?',
  a: 'La tasa MEP una vez por semana. El stock cada vez que recibís mercadería. Las comisiones de ML pocas veces al año.'
}, {
  q: '¿Puedo comprar solo un producto?',
  a: 'Sí, más abajo en la página están los 3 productos principales disponibles por separado. Aunque el Kit es la mejor relación precio-valor porque incluye los 2 bonos.'
}, {
  q: '¿Tienen soporte después de la compra?',
  a: 'Sí. Podés escribirnos por WhatsApp ante cualquier consulta sobre el contenido. Respondemos en menos de 24 horas.'
}];
function FAQItem({
  faq,
  isOpen,
  onToggle
}: {
  faq: (typeof faqs)[0];
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border border-navy/10 rounded-xl overflow-hidden" data-id="element-33">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-navy/3 transition-colors" data-id="element-34">
        <span className="font-display font-bold text-navy text-base md:text-lg pr-4" data-id="element-35">
          {faq.q}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.25
      }} className="shrink-0" data-id="element-36">
          <ChevronDownIcon className="w-5 h-5 text-navy/40" data-id="element-37" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-38">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-39">
            <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-40">
              <p className="text-navy/55 leading-relaxed" data-id="element-41">{faq.a}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream py-16 md:py-24" data-id="element-42">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-44">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-navy" data-id="element-45">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="space-y-3" data-id="element-46">
          {faqs.map((faq, i) => <FAQItem key={i} faq={faq} isOpen={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-47" />)}
        </motion.div>
      </div>
    </section>;
}